/* Pixelshop custom: livesök, dold toppsök, neutral kassa, färgval, usp */
(function () {
  var css = [
    '.header__icon--search{display:none!important}',
    'shopify-accelerated-checkout-cart,.additional-checkout-buttons,.cart__dynamic-checkout-buttons,shopify-accelerated-checkout{display:none!important}',
    '.px-search{position:relative;z-index:50}',
    '.px-search form{position:relative}',
    '.px-sug{position:absolute;left:0;right:0;top:calc(100% + 6px);background:#151a2b;border:1px solid #2c3354;border-radius:10px;box-shadow:0 18px 40px rgba(0,0,0,.55);overflow:hidden;display:none;max-height:min(70vh,560px);overflow-y:auto;text-align:left}',
    '.px-sug.open{display:block}',
    '.px-sug h6{margin:0;padding:10px 14px 6px;font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#8d93b8}',
    '.px-sug a{display:flex;align-items:center;gap:12px;padding:8px 14px;color:#e6e9f2;text-decoration:none;font-size:14px;line-height:1.3}',
    '.px-sug a:hover,.px-sug a.act{background:#232a45}',
    '.px-sug img{width:48px;height:48px;object-fit:contain;background:#fff;border-radius:6px;flex:none}',
    '.px-sug .t{flex:1;min-width:0;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}',
    '.px-sug .p{font-weight:700;color:#b9a8ff;white-space:nowrap}',
    '.px-sug .chip{display:inline-block;margin:0 0 8px 14px;padding:5px 10px;border-radius:999px;background:#232a45;font-size:13px}',
    '.px-sug .all{justify-content:center;font-weight:700;color:#b9a8ff;border-top:1px solid #2c3354}',
    '.px-sug .none{padding:14px;color:#8d93b8;font-size:14px}',
    'cookies-popup,#bls_cookies{display:none!important}',
    '.product-form__input label .value{background:#151a2b!important;color:#e6e9f2!important;border:1px solid #2c3354;border-radius:6px;padding:8px 14px;display:inline-block;min-width:44px;text-align:center;font-weight:600}',
    '.product-form__input input[type=radio]:checked+label .value{border-color:#7B5CFF;background:#2a2150!important;box-shadow:0 0 0 1px #7B5CFF}',
    '.product-form__input input[type=radio].disabled+label .value,.product-form__input input[type=radio]:disabled+label .value{opacity:.45;text-decoration:line-through}'
  ].join('');
  var st = document.createElement('style'); st.id = 'px-app-css'; st.textContent = css; document.head.appendChild(st);
  function money(c) { return (c / 100).toLocaleString('sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kr'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
  function usp() {
    document.querySelectorAll('.px-usp span').forEach(function (e) { if (/2–5 vardagar/.test(e.textContent)) e.textContent = e.textContent.replace('2–5 vardagar', '1–3 vardagar'); });
  }
  function relabel() {
    document.querySelectorAll('button[name=checkout],a[href="/checkout"],.cart__checkout-button').forEach(function (b) {
      if (/kolla in/i.test(b.textContent)) b.textContent = 'Till kassan';
    });
  }
  function initSearch() {
    var box = document.querySelector('.px-search');
    if (!box || box.dataset.pxLive) return;
    box.dataset.pxLive = 1;
    var form = box.querySelector('form'), inp = box.querySelector('input[type=search]');
    var sug = document.createElement('div'); sug.className = 'px-sug'; form.appendChild(sug);
    var timer, ctrl, act = -1;
    function close() { sug.classList.remove('open'); act = -1; }
    function render(q, r) {
      var prods = (r.products || []), cols = (r.collections || []), html = '';
      if (cols.length) html += '<h6>Kategorier</h6><div>' + cols.slice(0, 4).map(function (c) { return '<a class="chip" href="' + c.url + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
      if (prods.length) {
        html += '<h6>Produkter</h6>' + prods.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          return '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<img alt="">') + '<span class="t">' + esc(p.title) + '</span><span class="p">' + esc(p.price ? (String(p.price).indexOf('.') > -1 ? Number(p.price).toLocaleString('sv-SE') + ' kr' : money(p.price)) : '') + '</span></a>';
        }).join('');
        html += '<a class="all" href="/search?q=' + encodeURIComponent(q) + '&options[prefix]=last">Visa alla resultat för "' + esc(q) + '"</a>';
      }
      if (!html) html = '<div class="none">Inga träffar för "' + esc(q) + '"</div>';
      sug.innerHTML = html; sug.classList.add('open'); act = -1;
    }
    function run() {
      var q = inp.value.trim();
      if (q.length < 2) { close(); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (j) { if (inp.value.trim() === q) render(q, (j.resources && j.resources.results) || {}); })
        .catch(function () {});
    }
    inp.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    inp.addEventListener('focus', function () { if (sug.innerHTML && inp.value.trim().length > 1) sug.classList.add('open'); });
    inp.addEventListener('keydown', function (e) {
      var items = sug.querySelectorAll('a'); if (!sug.classList.contains('open') || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); if (act > -1) items[act].classList.remove('act');
        act = e.key === 'ArrowDown' ? (act + 1) % items.length : (act <= 0 ? items.length - 1 : act - 1);
        items[act].classList.add('act'); items[act].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && act > -1) { e.preventDefault(); location.href = items[act].href; }
      else if (e.key === 'Escape') close();
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
  }
  function init() { initSearch(); relabel(); usp(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(function () { relabel(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
